/**
 * Playtest-rig registry.
 *
 * One file per rig under this directory. RIGS is the canonical map
 * name → spec. ACTIVE_RIG_NAME is the single source of truth for
 * which rig DevConfig.playtestRig resolves to — Tier A's MCP
 * `dj_h2000_rig_set` rewrites this line.
 *
 * Adding a new rig:
 *   1. Create src/config/playtest-rigs/<name>.ts exporting a PlaytestRig
 *   2. Import + register in RIGS below
 *   3. (Optional) flip ACTIVE_RIG_NAME or use Tier A's MCP
 */

import type { PlaytestRig } from '../environment/devConfig';
import { SMOOTHNESS_ARC_RIG } from './smoothness-arc';
import { NO_RIG } from './none';
import { LAG_DEBUG_RIG } from './lag-debug';
import { PURE_FRAME_JITTER_RIG } from './pure-frame-jitter';
import { COMBAT_RIG } from './combat';

export const RIGS: Record<string, PlaytestRig> = {
  'smoothness-arc': SMOOTHNESS_ARC_RIG,
  'lag-debug': LAG_DEBUG_RIG,
  'pure-frame-jitter': PURE_FRAME_JITTER_RIG,
  'combat': COMBAT_RIG,
  'none': NO_RIG,
};

// Single line Tier A's rig_set rewrites. Keep the literal format stable
// (no template strings, no concatenation) so a regex find/replace works.
export const ACTIVE_RIG_NAME = 'none';

export function getActiveRig(): PlaytestRig {
  return RIGS[ACTIVE_RIG_NAME] ?? RIGS['none'];
}

export function listRigNames(): string[] {
  return Object.keys(RIGS);
}
